import { render, staticRenderFns } from "./NotificationWeb.vue?vue&type=template&id=2f108c73&"
import script from "./NotificationWeb.vue?vue&type=script&lang=js&"
export * from "./NotificationWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports